export default __webpack_public_path__ + "static/tablet-e636eded9c4637ba565556ded15f69bc.webp";